// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module
import computeStackTrace from 'ui-forms-embed-components-reporting/reporting/internal/computeStackTrace';
const IGNORED_ERROR_MESSAGES = [/timeout exceeded/, /Request aborted/, /Network Error/, /Failed to execute 'send' on 'XMLHttpRequest'/, /Unexpected end of JSON input/, /Unexpected token/, /IP_ADDRESS_IS_PROBABLY_A_BOT/, /SUBMISSION_PERIOD_ENDED/, /RATE_LIMIT_EXCEEDED/, /Failed to execute 'removeChild' on 'Node'/, /Failed to execute 'insertBefore' on 'Node'/];
const IGNORED_ERROR_STACKS = [/\/OtAutoBlock\.js/,
// OtAutoBlock replaces document.createElement
/\/mootools\.js/ // mootools replacing Function.prototype.bind non-standard
];
const IS_FORM_SCRIPT_ORIGIN = [/ui-forms-embed-components/,
// frame embed container script and share page form scripts
/embed-default-modules/,
// SSR form script
/\/?forms\/embed\/(frame(-v2)?|\d+)\.js/,
// frame embed parent script
/web-interactives-embed-framework/ // web interactive framework script
];
const isErrorFromEmbedScript = (error, isTest) => {
  const stackTrace = computeStackTrace(error);
  const filename = stackTrace.stack ? stackTrace.stack[0].filename : stackTrace.filename;
  return IS_FORM_SCRIPT_ORIGIN.some(s => s.test(error.stack || '')) && (isTest ? true : IS_FORM_SCRIPT_ORIGIN.some(s => s.test(filename)));
};
const isErrorReportable = (error, isTest = false) => {
  if (!error) return false;
  const {
    message = '',
    stack = ''
  } = error;
  return Boolean(message && stack && isErrorFromEmbedScript(error, isTest) && !IGNORED_ERROR_MESSAGES.find(s => s.test(message)) && !IGNORED_ERROR_STACKS.find(s => s.test(stack)));
};
export default isErrorReportable;